import { EInfrastructureActionType, ISetTypesPayload } from './types';
import { getTermsValue } from '../../../../packages/JsonQuery';
import { fetchInfrastructureTypes as fetchInfrastructureTypesService } from '../../../common/services/infrastructure';
import { TThunkAction } from '../../../common/types/redux';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

const setTypes = actionGenerator<EInfrastructureActionType.SetTypes, ISetTypesPayload>(
  EInfrastructureActionType.SetTypes,
);

const resetTypes = actionGenerator<EInfrastructureActionType.ResetActiveType>(
  EInfrastructureActionType.ResetActiveType,
);

export function fetchInfrastructureTypes(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      filters: { jsonQuery },
    } = getState();
    const regionIds = getTermsValue('region')(jsonQuery);

    if (regionIds === null) {
      dispatch(resetTypes());

      return;
    }

    const types = await fetchInfrastructureTypesService(
      {
        region: regionIds.join(','),
      },
      context,
    );

    dispatch(setTypes({ types }));
  };
}
